import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'

import { PhishingTable } from './components'

import useFetch from 'hooks/useFetch'
import * as service from 'service'
import usePagination from 'hooks/usePagination'
import useSearch from 'hooks/useSearch'

import constants from 'constants/index'

const MyPhishing = ({ filter, currentTab }) => {
  const { perPage, page, handleChangePage, handleChangeRowsPerPage } =
    usePagination(10)

  const { searchInput, handleSearchValue, isSearching } = useSearch((value) => {
    const newFilters = { ...filter.filters }
    if (value) {
      newFilters.name = value
    } else {
      delete newFilters.name
    }
    filter.setFilters(newFilters)
  })

  const statusFilter =
    currentTab !== constants.phishing.ALL_TAB_VALUE
      ? { status: currentTab }
      : {}
  const { response, isLoading, refresh } = useFetch(
    service.dponet.phishingCampaigns.get,
    { perPage, page, ...filter.filters, ...statusFilter },
    [page, perPage, filter.filters, currentTab],
  )

  const handleDelete = async (phishingCampaignId) => {
    await service.dponet.phishingCampaigns.destroy(phishingCampaignId)
    refresh()
  }

  const phishings = response?.data?.phishingCampaigns

  return (
    <Box display="flex" flexDirection="column" pt={3}>
      <PhishingTable
        phishings={phishings}
        isLoading={isLoading}
        searchInput={searchInput}
        isSearching={isSearching}
        handleSearchValue={handleSearchValue}
        onDelete={handleDelete}
        count={response?.data?.meta?.totalCount || 0}
        pagination={{
          perPage,
          page,
          handleChangePage,
          handleChangeRowsPerPage,
        }}
      />
    </Box>
  )
}

MyPhishing.propTypes = {
  filter: PropTypes.object.isRequired,
  currentTab: PropTypes.string.isRequired,
}

export default MyPhishing
